import { Highlight, connectRefinementList } from "react-instantsearch-dom";
import { orderBy, sortBy, chain } from "lodash";
import styled from "styled-components";
import parse from 'html-react-parser';

import Checkbox from "./Checkbox";


const ItemLabel = styled.span`
  margin-left: 8px;
  font-family: Open Sans, sans-serif;
  font-size: 16px;
  font-weight: ${(props) => (props.checked ? 600 : "normal")};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.05;
  letter-spacing: normal;
  text-align: left;
  color: ${(props) => (props.disabled ? '#95938D' : "#2c271c")};

  i {
    font-family: Open Sans, sans-serif;
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.17;
    letter-spacing: normal;
    text-align: left;
  }


}`;

const ItemCount = styled.span`
border: none;
font-family: Open Sans, sans-serif;;
font-size: 12px;
font-weight: 600;
font-stretch: normal;
font-style: normal;
line-height: 1.42;
letter-spacing: normal;
text-align: center;
color: #2c271c;
text-align: center;
text-decoration: none;
display: inline-block;
padding: 1px 4px 1px;
border-radius: 10px;
background-color: #e6e6e6;
margin-left: 5px;
}`;

const currentItemRefinement = new Set();

//const initialFacets = window.all_material_types;




function uniqBy(items, property) {
  const seen = {};

  return items.filter(item => {
    const val = item[property];

    if (seen[val]) {
      return false;
    } else {
      seen[val] = true;
      return true;
    }
  });
}

const RefinementList = ({
  items,
  isFromSearch,
  refine,
  searchForItems,
  createURL,
  currentRefinement,
  initialFacets,
  initialSort,
  attribute,
  limit
}) => {

  if (initialFacets && initialFacets.length > 0) {
    initialFacets.map(i =>
      i.isRefined = false
    );
    //console.log('MATinitialFacets', initialFacets);
  }

  if (attribute === 'material_type_names') {
    //console.log('material_type_names', items);
  }


  //console.log('MATITEMS', items);
  //console.log('MAcurrentRefinement', currentRefinement);
  //console.log('MAcurrentRefinementSET', currentItemRefinement);


  const toggle = item => {  // update `currentItemRefinement` on toggle
    //console.log('MATtoggle', item);
    currentItemRefinement.clear();
    item.value.forEach(value => currentItemRefinement.add(value));
    //console.log('MATAftertoggle', item);
    // didn't use new Set([...]) because IE 11 doesn't support it.
    // ref: http://kangax.github.io/compat-table/es6/#test-Set
    refine(item.value);
  };



  const combinedItems = uniqBy([...items, ...initialFacets], 'label')
    .slice(0, 50)
    .map(item => {
      // Here we re-calculate `isRefined` and `value` for each item
      // based on `currentItemRefinement` which we cached at `toggle`.
      //const isRefined = currentItemRefinement.has(item.label);
      const isRefined = currentRefinement.includes(item.label);

      //remove item from currentItemRefinement if !isRefined
      //console.log('MAcurrentItemRefinementPRE', currentItemRefinement);
      //console.log('MACuR', isRefined);
      if (!isRefined) {
        //console.log('MACuRremove', item.label);
        //currentItemRefinement.delete(item.label);
      }
      //console.log('MAcurrentItemRefinementPOST', currentItemRefinement);

      const value =
        isRefined === false
          ? [...currentRefinement, item.label]
          : [...currentRefinement].filter(label => label !== item.label);
      const newItem = item;
      newItem.isRefined = isRefined;
      newItem.value = value;
      //console.log('MATcombinedItems', item);
      //console.log('MATcombinedItemsNEW', newItem);
      return {
        ...item,
        isRefined,
        value,
      };
    });

    let sortedItems = orderBy(combinedItems, ['label'],['asc']);



    //console.log('MATitems', items);
    //console.log('MATsortedItems', sortedItems);


    sortedItems.map(s => {
      let item = items.filter((e) => e.label === s.label);
      if (item) {
        if (item.length > 0) {

          if (item[0].isRefined === true) {
            s.isRefined = true;
          }

          if (s.isRefined === true && item[0].isRefined === false) {
            s.isRefined = false;
          }

        }
      }
      return s;
    });

    if (initialSort && initialSort.length > 0) {
      sortedItems.sort(function (a, b) {
        return initialSort.indexOf(a.label) - initialSort.indexOf(b.label);
      });
    }

    const formatLabel = (label) => {
      if (attribute !== 'secondary_building_system_names') {
        let newLabel = label.replace('(', '<i className="filter-helper">(').replace(')', ')</i>');
        return parse(newLabel);
      } else {
        return label;
      }
    }

  const _onMouseOver = () => {
    //console.log('sdf');
  }

  return (
  <div>
    <ul style={{ listStyle: "none outside none" }}>
      {sortedItems.map((item, index) => (
        <li key={item.label + "-" + index} className='filter-checkbox-items'>
          <label>
            <Checkbox disabled={item.count > 0 ? false : true} checked={item.isRefined} onChange={() => {
              if (item.count > 0) {
                toggle(item)
              }
            }
            } />
            <ItemLabel checked={item.isRefined} disabled={item.count > 0 ? false : true}>
              {formatLabel(item.label)}
              <ItemCount>{item.count}</ItemCount>
            </ItemLabel>
          </label>
        </li>
      ))}
    </ul>
  </div>
)
}
const CheckBoxRefinementList = connectRefinementList(RefinementList);
export default CheckBoxRefinementList;
